<div
  class="filter-wrapper"
  [style.grid-template-columns]="gridTemplateColumns$ | async"
>
  <wilson-basic-search-filter
    (inputChanged)="updateSearchTerm($event)"
    [debounceTime]="200"
  ></wilson-basic-search-filter>

  <wilson-organizational-unit-filter
    class="mb-2"
    (modelChange)="orgUnitsChanged($event)"
  ></wilson-organizational-unit-filter>

  <div class="grouped-filters-wrapper">
    <ng-content></ng-content>
  </div>
</div>
